export interface DrawerState {
  name?: string;
  data: any;
}

export const drawerState: DrawerState = {
  name: undefined,
  data: undefined,
};
